var defaultResets = {
	placeholder : function() {
		if(!Modernizr.input.placeholder){
			$('[placeholder]').focus(function() {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
					input.removeClass('ph');
				}
			}).blur(function() {
				var input = $(this);
				if (input.val() === '' || input.val() == input.attr('placeholder')) {
					input.addClass('ph');
					input.val(input.attr('placeholder'));
				}
			}).blur();
			$('[placeholder]').parents('form').submit(function() {
				$(this).find('[placeholder]').each(function() {
					var input = $(this);
					if (input.val() == input.attr('placeholder')) {
						input.val('');
					}
				});
			});
		}
	},
	title : function() {
		$('[title]').each(function(){
			$(this).data('original-title', $(this).attr('title'));
		}).hover(function () {
			$(this).attr('title','');
		}, function () {
			$(this).attr('title',$(this).data('original-title'));
		});
	},
	buttonTarget : function() {
		$('[data-href]').click( function( e ){
			var target = $(e.target);
			if ( target.not( 'a' ) && !target.parent( 'a' ).length ) {
				if ( $( this ).attr( 'data-window' ) == 'new' ) {
					window.open( $( this ).attr( 'data-href' ) );
				} else {
					window.location.href = $( this ).attr( 'data-href' );
				}
				return false;
			}
		});
	},
	init : function() {
		defaultResets.placeholder();
		defaultResets.title();
		defaultResets.buttonTarget();
	}
}
